import { SECTORS } from "./data";
import { PageFooter, Corner } from "./chrome";

export default function SectorsPage() {
  return (
    <section className="page" data-testid="page-sectors">
      <div className="grain" />
      <Corner section="III · Sectors" />
      <div className="page-inner">
        <div className="section-header">
          <div className="eyebrow">Sectors We Serve</div>
          <h2 className="h-title">
            Solar for <em>every</em> rooftop.
          </h2>
        </div>

        <p className="body" style={{ maxWidth: "70%" }}>
          Whether you are powering a family home, a retail showroom or a 200 kW industrial shed — our solar design, EPC and maintenance approach is calibrated to your sector, your load profile and your budget.
        </p>

        <div className="sector-grid">
          {SECTORS.map((s) => (
            <div className="sector-card" key={s.title}>
              <div className="photo" style={{ backgroundImage: `url(${s.img})` }}>
                <div className="badge">
                  {s.count}
                  <small>{s.metric}</small>
                </div>
              </div>
              <div className="desc">
                <h4>{s.title}</h4>
                <p>{s.desc}</p>
                <div className="region">{s.region}</div>
              </div>
            </div>
          ))}
        </div>

        <div style={{ marginTop: 32, display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 18, paddingTop: 24, borderTop: "1px solid var(--line-2)" }}>
          <div>
            <div className="eyebrow">Coverage</div>
            <p className="body" style={{ marginTop: 10 }}>Active sites spanning Bangalore Urban, Bangalore Rural, Tumakuru, Mysuru and the broader Karnataka geography.</p>
          </div>
          <div>
            <div className="eyebrow">Standards</div>
            <p className="body" style={{ marginTop: 10 }}>BIS-certified modules, MNRE-empaneled installers, BESCOM-approved net-metering with grid-tied inverters.</p>
          </div>
          <div>
            <div className="eyebrow">Warranty</div>
            <p className="body" style={{ marginTop: 10 }}>25-year performance warranty on modules, 5–10 years on inverters and 5-year workmanship guarantee from INPACE POWER.</p>
          </div>
        </div>
      </div>
      <PageFooter num="08" />
    </section>
  );
}
